import './App.css';
import Booking from './components/Booking';

function App() {
  return (
    <div className="App">
      <Booking />
    </div>
  );
}

export default App;
